import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Modal from "react-modal";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import moment from "moment-timezone";
import Rebase from "re-base";
// eslint-disable-next-line no-unused-vars
import { SvgNurse, SvgLocations } from "./SvgLib";
import VideoVisit from "./VideoVisit";
import dbSync from "../config/database";
import { ActionCreators } from "../actions";

const dbLive = Rebase.createClass(dbSync);

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const customStyles = {
  overlay: {
    backgroundColor: "rgba(255, 255, 255, 1)"
  },
  content: {
    top: "0",
    left: "0",
    right: "auto",
    bottom: "auto",
    marginRight: "0",
    transform: "translate(0, 0)",
    border: "none"
  }
};

const hostName = window.location.hostname;
const protocol = window.location.protocol;
const host = `${protocol}//${hostName}`;

function Header(props) {
  const [state, setState] = useState({
    providerFilterName: "Nurse/Doctor",
    locationFilterName: "Location",
    providerCollection: [],
    locationCollection: [],
    locationDistances: [{ distance: "Looking for your location" }],
    expanded: false,
    window_height: props.height,
    width: "0",
    height: "0",
    modalIsOpen: false,
    filterActive: false,
    toggleTimeslotDuration: false,
    open: false,
    openLocationSelect: false,
    filteredTimeslots: false,
    // Use a numeric timestamp instead of Date#toString(). Safari does not
    // reliably parse that display format when it is passed back to Moment.
    dateToday: moment().valueOf(),
    coordLatitudeUser: "",
    coordLongitudeUser: "",
    coordsEnabled: false
  });
  const handleCallScheduling = () => {
    if (props.DATA_fetch_locations !== undefined) {
      const locations = props.DATA_fetch_locations;
      const locationKeys = Object.keys(locations);
      const locationKey = locationKeys.find(
        locationKeyI => locations[locationKeyI].name === "Phone Visit"
      );
      const location = locations[locationKey];
      const dataToUpdate = {
        locationFilterName: location ? location.name : "Phone Visit",
        locationFilterID: locationKey
      };

      setState(prevState => ({ ...prevState, ...dataToUpdate }));
      props.functionSetTimeslotFilterName(
        dataToUpdate.locationFilterName,
        dataToUpdate.locationFilterID
      );

      setState(prevState => ({
        ...prevState,
        expanded: false,
        openLocationSelect: false,
        modalIsOpen_animate: false,
        filterActive: false,
        showTimeslots: true,
        filteredTimeslots: true
      }));
    }

    props.functionFilteredTS(true);

    const allTs = Object.values(props.DATA_fetch_soonest_ADVANCED);
    const locName = state.locationFilterName;
    const probeName = state.providerFilterName;
    const closesFilteredProvider = allTs.find(obj => {
      if (probeName === "Nurse/Doctor" && locName === "Location") {
        return obj.appointment === false;
      }
      if (probeName !== "Nurse/Doctor" && locName === "Location") {
        return obj.appointment === false && obj.providerName === probeName;
      }
      if (probeName === "Nurse/Doctor" && locName !== "Location") {
        return obj.appointment === false && obj.locationName === locName;
      }
      if (probeName !== "Nurse/Doctor" && locName !== "Location") {
        return (
          obj.appointment === false &&
          obj.locationName === locName &&
          obj.providerName === probeName
        );
      }

      return false;
    });

    if (closesFilteredProvider) {
      const triggeredSoonest = true;
      const triggeredSoonestTime = closesFilteredProvider.duration.start;
      props.functionFetchTimeslotsSoonestTriggered(
        triggeredSoonest,
        triggeredSoonestTime
      );
    }
  };

  // eslint-disable-next-line no-unused-vars
  const handleClickOpenNurses = () => {
    setState(prevState => ({ ...prevState, open: true, filterActive: true }));

    setTimeout(() => {
      setState(prevState => ({ ...prevState, modalIsOpen_animate: true }));
    }, 300);
  };

  const handleClose = () => {
    setState(prevState => ({ ...prevState, modalIsOpen_animate: false }));

    setTimeout(() => {
      setState(prevState => ({
        ...prevState,
        open: false,
        filterActive: false
      }));
    }, 300);
  };

  const updateWindowDimensions = () => {
    setState(prevState => ({
      ...prevState,
      width: window.innerWidth,
      height: document.getElementById("root").scrollHeight - 88
    }));
  };

  useEffect(
    () => {
      const validPaths = ["/schedule/phone-visit/", "/schedule/phone-visit"];
      if (
        props.DATA_fetch_locations &&
        validPaths.includes(window.location.pathname)
      ) {
        handleCallScheduling();
      }
    },
    [props.DATA_fetch_locations]
  );

  useEffect(() => {
    setState(prevState => ({
      ...prevState,
      window_height: `${document.getElementById("root").offsetHeight - 118}px`
    }));

    const url = "https://api.ipify.org?format=json";
    fetch(url)
      .then(response => response.json())
      .then(responseJson => {
        const whoisthis = {
          countryName: responseJson.country_name
        };

        props.StoreUserInfo(whoisthis);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    const startingTime = moment.tz(state.dateToday, "America/Denver").valueOf();
    const endingTime = moment(state.dateToday)
      .add(19, "days")
      .valueOf();

    props.functionFetchTimeslotsSoonestAdvanced(startingTime, endingTime);
    props.functionFetchTimeslotsSoonest(startingTime);

    dbLive.listenTo(`/app/timeslots`, {
      context: { window },
      asArray: true,
      queries: {
        orderByChild: "durationTimestamp/start"
      },
      then: () => {
        setState(prevState => ({
          ...prevState,
          providerFilterName: "Nurse/Doctor"
        }));
        props.functionSetTimeslotFilter(state.providerFilterName);

        setState(prevState => ({
          ...prevState,
          locationFilterName: "Location"
        }));
        props.functionSetTimeslotFilterName(state.locationFilterName);
      }
    });

    const d_start = moment().valueOf();
    const d_end = moment()
      .add(19, "days")
      .set({ hour: 5, minute: 0, second: 0, millisecond: 0 })
      .valueOf();

    props.f_FETCH_Providers();
    props.f_FILTERED_Providers(d_start, d_end);

    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);

    props.functionSetTimeslotFilter(state.providerFilterName);
    props.functionSetTimeslotFilterName(state.locationFilterName);

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        const coordLatitudeUser = position.coords.latitude;
        const coordLongitudeUser = position.coords.longitude;

        setState(prevState => ({
          ...prevState,
          coordLatitudeUser,
          coordLongitudeUser,
          coordsEnabled: true
        }));

        const geo = {
          coordLongitudeUser,
          coordLatitudeUser,
          coordsEnabled: state.coordsEnabled
        };

        props.actionSetGeoLocations(geo);
      });
    }

    const oneHourAppointments = false;
    props.functionSelectedHours(oneHourAppointments);

    return () => {
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const handleProviderSelect = e => {
    e.preventDefault();
    const providerFilterName = e.currentTarget.getAttribute("data-value");

    if (providerFilterName) {
      setState(prevState => ({ ...prevState, providerFilterName }));
      props.functionSetTimeslotFilter(providerFilterName);
    }

    setState(prevState => ({
      ...prevState,
      expanded: false,
      open: false,
      modalIsOpen_animate: false,
      filterActive: false,
      showTimeslots: true,
      filteredTimeslots: true
    }));

    props.functionFilteredTS(true);

    const allTs = Object.values(props.DATA_fetch_soonest_ADVANCED);
    const locName = state.locationFilterName;

    const closesFilteredProvider = allTs.find(obj => {
      if (providerFilterName === "Nurse/Doctor" && locName === "Location") {
        return obj.appointment === false;
      }
      if (providerFilterName !== "Nurse/Doctor" && locName === "Location") {
        return (
          obj.appointment === false && obj.providerName === providerFilterName
        );
      }
      if (providerFilterName === "Nurse/Doctor" && locName !== "Location") {
        return obj.appointment === false && obj.locationName === locName;
      }
      if (providerFilterName !== "Nurse/Doctor" && locName !== "Location") {
        return (
          obj.appointment === false &&
          obj.locationName === locName &&
          obj.providerName === providerFilterName
        );
      }
      return false;
    });

    if (closesFilteredProvider) {
      const triggeredSoonest = true;
      const triggeredSoonestTime = closesFilteredProvider.duration.start;

      props.functionFetchTimeslotsSoonestTriggered(
        triggeredSoonest,
        triggeredSoonestTime
      );
    }
  };
  const handleClickInPersonVisit = () => {
    if (window.showDialogFromButton) {
      window.showDialogFromButton();
    }
  };

  // eslint-disable-next-line no-unused-vars
  const handleProviderSelectAll = e => {
    e.preventDefault();

    const providerFilterName = e.currentTarget.getAttribute("data-value");
    if (providerFilterName) {
      setState(prevState => ({
        ...prevState,
        providerFilterName: "Nurse/Doctor"
      }));
      props.functionSetTimeslotFilter("Nurse/Doctor");
    }

    setState(prevState => ({ ...prevState, expanded: false }));

    // reset soonest
    const triggeredSoonest = true;
    const triggeredSoonestTime = state.soonestTimeslotTime;
    props.functionFetchTimeslotsSoonestTriggered(
      triggeredSoonest,
      triggeredSoonestTime
    );
  };

  const handleLocationSelectAll = e => {
    e.preventDefault();
    const locationFilterName = e.currentTarget.getAttribute("data-value");

    if (locationFilterName) {
      setState(prevState => ({ ...prevState, locationFilterName: "Location" }));
      props.functionSetTimeslotFilterName("Location");
    }

    setState(prevState => ({ ...prevState, expanded: false }));

    // reset soonest
    const triggeredSoonest = true;
    const triggeredSoonestTime = state.soonestTimeslotTinme;
    props.functionFetchTimeslotsSoonestTriggered(
      triggeredSoonest,
      triggeredSoonestTime
    );
  };

  const openModalMenu = () => {
    setState(prevState => ({ ...prevState, modalIsOpen: true }));
  };

  const closeModal = () => {
    setState(prevState => ({ ...prevState, modalIsOpen: false }));
  };

  return (
    <div
      className={`mainHeader ${state.expanded ? "location_search_on" : null}`}
    >
      <div className="topHeader">
        <div className="topHeaderInner">
          <div className="topHeaderLeft">
            <button className="sandwitch" onClick={openModalMenu}>
              <span>menu</span>
            </button>

            <h1>Schedule appointment</h1>
          </div>

          <Modal
            overlayClassName="scheduleNavModalOverlay"
            className={{
              base: "scheduleNavModal",
              afterOpen: "scheduleNavModal-open",
              beforeClose: "scheduleNavModal-close"
            }}
            isOpen={state.modalIsOpen}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal"
          >
            <button
              className={`sandwitch is-active ${
                state.modalIsOpen_animate
                  ? "animateSlideDown"
                  : "animateSlideDown o_n"
              }`}
              onClick={closeModal}
            >
              <span>close</span>
            </button>

            <div className="modalMenu_navs">
              <ul>
                <li>
                  <a href={host}>Home</a>
                </li>
                <li>
                  <li>
                    <a href={`${host}/about-video-visit/`}>Video Visit</a>
                  </li>
                  <li>
                    <a href={`${host}/resources/`}>Resources</a>
                  </li>
                  <a href={`${host}/find-a-clinic`}>Find a clinic</a>
                </li>
                <li>
                  <a href={`${host}/about-us/`}>About</a>
                </li>
                <li>
                  <a href={`${host}/our-services/`}>Our services</a>
                </li>
                <li>
                  <a href={`${host}/about-us/#Bios`}>Team Bios</a>
                </li>
                <li>
                  <a href={`${host}/birth-control-methods/`}>
                    Birth control options
                  </a>
                </li>
                <li>
                  <a href={`${host}/faq/`}>FAQ</a>
                </li>
              </ul>

              <div className="header_socials">
                <a
                  href="http://www.facebook.com/BC4UDenver"
                  className="social_links"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 44 44"
                    enableBackground="new 0 0 44 44"
                  >
                    <linearGradient
                      id="SVGID_1_id1"
                      gradientUnits="userSpaceOnUse"
                      x1="0"
                      y1="22"
                      x2="43.9216"
                      y2="22"
                    >
                      <stop offset="0" style={{ stopColor: "#F68628" }} />
                      <stop offset="1" style={{ stopColor: "#EF3C39" }} />
                    </linearGradient>
                    <path
                      fill="url(#SVGID_1_id1)"
                      d="M22,0C9.8,0,0,9.9,0,22c0,12.1,9.8,22,22,22c12.1,0,22-9.9,22-22C43.9,9.9,34.1,0,22,0z M32.6,31.3 c0,0.6-0.3,1.3-1,1.3h-5.4v-8.1H29l0.4-3.5h-3.2V19c0-0.9,0.2-1.4,1.6-1.4h1.9v-3c-0.6,0-1.5-0.1-2.6-0.1c-2.4,0-4.3,1.5-4.3,4.2 v2.4h-2.9v3.5h2.9v8.1h-10c-0.6,0-1-0.7-1-1.3V12.4c0-0.6,0.3-1.2,1-1.2h18.9c0.6,0,1,0.5,1,1.2V31.3z"
                    />
                  </svg>
                </a>

                <a
                  href="http://instagram.com/bc4ucolorado"
                  className="social_links"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 44 44"
                    enableBackground="new 0 0 44 44"
                  >
                    <linearGradient
                      id="SVGID_1_id3"
                      gradientUnits="userSpaceOnUse"
                      x1="3.940000e-002"
                      y1="22"
                      x2="43.9609"
                      y2="22"
                    >
                      <stop offset="0" style={{ stopColor: "#F68829" }} />
                      <stop offset="1" style={{ stopColor: "#EF3D39" }} />
                    </linearGradient>
                    <path
                      fill="url(#SVGID_1_id3)"
                      d="M25.9,22c0,1.9-1.6,3.5-3.5,3.5c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5 C24.3,18.5,25.9,20.1,25.9,22z M30.9,17.7C31,18.8,31,19.2,31,22c0,2.8,0,3.2-0.1,4.3c0,1-0.2,1.6-0.4,2c-0.2,0.5-0.4,0.8-0.8,1.2 c-0.4,0.4-0.7,0.6-1.2,0.8c-0.4,0.1-0.9,0.3-2,0.4c-1.1,0.1-1.4,0.1-4.3,0.1c-2.8,0-3.2,0-4.3-0.1c-1,0-1.6-0.2-2-0.4 c-0.5-0.2-0.8-0.4-1.2-0.8c-0.4-0.4-0.6-0.7-0.8-1.2c-0.1-0.4-0.3-0.9-0.4-2c-0.1-1.1-0.1-1.5-0.1-4.3c0-2.8,0-3.2,0.1-4.3 c0-1,0.2-1.6,0.4-2c0.2-0.5,0.4-0.8,0.8-1.2c0.4-0.4,0.7-0.6,1.2-0.8c0.4-0.1,0.9-0.3,2-0.4c1.1-0.1,1.4-0.1,4.3-0.1 c2.8,0,3.2,0,4.3,0.1c1,0,1.6,0.2,2,0.4c0.5,0.2,0.8,0.4,1.2,0.8c0.4,0.4,0.6,0.7,0.8,1.2C30.7,16.1,30.9,16.7,30.9,17.7z M27.8,22 c0-3-2.4-5.4-5.4-5.4c-3,0-5.4,2.4-5.4,5.4c0,3,2.4,5.4,5.4,5.4C25.3,27.4,27.8,25,27.8,22z M29.2,16.4c0-0.7-0.6-1.3-1.3-1.3 c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3C28.7,17.6,29.2,17.1,29.2,16.4z M44,22c0,12.1-9.8,22-22,22C9.9,44,0,34.1,0,22 C0,9.9,9.9,0,22,0C34.1,0,44,9.9,44,22z M32.9,22c0-2.9,0-3.2-0.1-4.4c-0.1-1.1-0.2-1.9-0.5-2.6c-0.3-0.7-0.6-1.3-1.2-1.9 c-0.6-0.6-1.2-1-1.9-1.2c-0.7-0.3-1.4-0.4-2.6-0.5c-1.1-0.1-1.5-0.1-4.4-0.1c-2.9,0-3.2,0-4.4,0.1c-1.1,0.1-1.9,0.2-2.6,0.5 c-0.7,0.3-1.3,0.6-1.9,1.2c-0.6,0.6-0.9,1.2-1.2,1.9c-0.3,0.7-0.4,1.4-0.5,2.6c-0.1,1.1-0.1,1.5-0.1,4.4c0,2.9,0,3.2,0.1,4.4 c0.1,1.1,0.2,1.9,0.5,2.6c0.3,0.7,0.6,1.3,1.2,1.9c0.6,0.6,1.2,1,1.9,1.2c0.7,0.3,1.4,0.4,2.6,0.5c1.1,0.1,1.5,0.1,4.4,0.1 c2.9,0,3.2,0,4.4-0.1c1.1-0.1,1.9-0.2,2.6-0.5c0.7-0.3,1.3-0.6,1.9-1.2c0.6-0.6,0.9-1.2,1.2-1.9c0.3-0.7,0.4-1.4,0.5-2.6 C32.9,25.2,32.9,24.9,32.9,22z"
                    />
                  </svg>
                </a>

                <a
                  href="https://www.snapchat.com/add/bc4u"
                  className="social_links"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg
                    data-name="Layer 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 44 44"
                  >
                    <defs>
                      <linearGradient
                        id="a"
                        y1="22"
                        x2="44"
                        y2="22"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" stopColor="#db8333" />
                        <stop offset="1" stopColor="#dc3636" />
                      </linearGradient>
                    </defs>
                    <path
                      d="M22 0a22 22 0 1 0 22 22A22 22 0 0 0 22 0zm11 27.87c-.22.53-1.17.91-2.89 1.18a2.15 2.15 0 0 0-.16.52c0 .17-.07.33-.12.51a.51.51 0 0 1-.51.38 2.67 2.67 0 0 1-.49-.06 5.59 5.59 0 0 0-1.18-.13 6.2 6.2 0 0 0-.84.07 4 4 0 0 0-1.57.82 5 5 0 0 1-3 1.18h-.28a5 5 0 0 1-3-1.18 4 4 0 0 0-1.57-.82 6.2 6.2 0 0 0-.84-.07 5.59 5.59 0 0 0-1.18.14 3.59 3.59 0 0 1-.49.07.53.53 0 0 1-.54-.39c-.05-.18-.09-.35-.12-.52a2.15 2.15 0 0 0-.16-.52c-1.72-.27-2.67-.65-2.89-1.18a.46.46 0 0 1-.05-.2.47.47 0 0 1 .38-.48c3-.49 4.34-3.56 4.39-3.69a1 1 0 0 0 .11-.81c-.17-.4-.81-.61-1.23-.74l-.32-.11c-1-.4-1.16-.86-1.1-1.18a1.08 1.08 0 0 1 1.07-.73.78.78 0 0 1 .35.07 2.43 2.43 0 0 0 1 .27.79.79 0 0 0 .43-.1v-.53a11.06 11.06 0 0 1 .27-4.45 5.87 5.87 0 0 1 5.44-3.51h.43a5.86 5.86 0 0 1 5.45 3.51c.49 1.09.37 3 .27 4.45v.53a.83.83 0 0 0 .37.1 2.88 2.88 0 0 0 .95-.27 1 1 0 0 1 .42-.09 1.18 1.18 0 0 1 .46.09.9.9 0 0 1 .67.77c0 .42-.37.78-1.11 1.07l-.32.11c-.42.13-1.06.34-1.23.74a1 1 0 0 0 .11.81c.05.13 1.4 3.2 4.39 3.69a.47.47 0 0 1 .38.48.46.46 0 0 1-.15.2z"
                      fill="url(#a)"
                    />
                  </svg>
                </a>

                <a
                  href="http://www.youtube.com/user/BirthControl4U"
                  className="social_links"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 45 44"
                    enableBackground="new 0 0 45 44"
                  >
                    <linearGradient
                      id="SVGID_1_id4"
                      gradientUnits="userSpaceOnUse"
                      x1="0.9019"
                      y1="22"
                      x2="44.8234"
                      y2="22"
                    >
                      <stop offset="0" style={{ stopColor: "#F68528" }} />
                      <stop offset="1" style={{ stopColor: "#EF3C39" }} />
                    </linearGradient>
                    <path
                      fill="url(#SVGID_1_id4)"
                      d="M20.2,18.4l6.9,3.6l-6.9,3.6L20.2,18.4z M44.8,22c0,12.1-9.8,22-22,22c-12.1,0-22-9.9-22-22 c0-12.2,9.8-22,22-22C35,0,44.8,9.9,44.8,22z M35.6,21.3c0-2.1-0.3-4.1-0.3-4.1s-0.2-1.8-1-2.5c-1-1-2.1-1-2.6-1.1 c-3.6-0.3-8.9-0.3-8.9-0.3h0c0,0-5.3,0-8.9,0.3c-0.5,0.1-1.6,0.1-2.6,1.1c-0.8,0.8-1,2.5-1,2.5s-0.3,2.1-0.3,4.1v1.9 c0,2.1,0.3,4.1,0.3,4.1s0.2,1.8,1,2.5c1,1,2.2,1,2.8,1.1c2,0.2,8.7,0.3,8.7,0.3s5.4,0,8.9-0.3c0.5-0.1,1.6-0.1,2.6-1.1 c0.8-0.8,1-2.5,1-2.5s0.3-2.1,0.3-4.1V21.3z"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </Modal>

          {!state.expanded &&
            !state.filterActive && (
              <a href="../">
                <div className="logo logoScheduleWhite" />
              </a>
            )}
        </div>
      </div>
      <div className="blockInner phoneVisitScheduleContainer">
        {!state.filteredTimeslots && <VideoVisit />}
      </div>
      <div className="blockInner phoneVisitScheduleContainer">
        {!state.filteredTimeslots && (
          <h1 className="title-header">In-Person or Phone Visit</h1>
        )}
        {!state.filteredTimeslots && (
          <h3 className="video-visit-center">
            In-person visits available in Aurora, Broomfield, Highlands Ranch or
            Wheat Ridge.
          </h3>
        )}
        {!state.filteredTimeslots && (
          <div>
            <div className="filterNurseDoctor_wrapper _colorMaroon">
              <Button
                onClick={handleClickInPersonVisit}
                className="filterNurseDoctor"
              >
                Schedule In-Person or Phone Visit
              </Button>
              {state.locationFilterName !== "Location" ? (
                <div
                  className="search_loc_selector_reset"
                  onClick={handleLocationSelectAll}
                  onKeyDown={handleLocationSelectAll}
                  data-value="Location"
                  role="presentation"
                >
                  X
                </div>
              ) : null}
            </div>
          </div>
        )}
      </div>

      {/* The phone visit was temporarily suspended at the client's request.  */}
      {/* <div className="blockInner phoneVisitScheduleContainer">
        {!state.filteredTimeslots && (
          <h1 className="title-header">Phone Visit</h1>
        )}
        {!state.filteredTimeslots && (
          <h3 className="video-visit-center">
            If you do not find what you are looking for, click “Schedule an
            In-Person Visit”, click through the first few steps and select
            “Telehealth” for more options.
          </h3>
        )}

        {!state.filteredTimeslots && (
          <button
            onClick={() => {}}
            className={`meAndMyFriend ${
              state.oneHourAppointments ? "durationToggleOn" : ""
            }`}
            style={{ cursor: "default" }}
          >
            <div className="div_durationToggle" id="btn_justme">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.5 30">
                <path
                  className="st0"
                  d="M26.8 30H.7c-.4 0-.7-.3-.7-.7v-2.6c0-2.1 1.3-3.9 3.2-4.6l6.4-2.3v-3.3H11v3.8c0 .3-.2.6-.5.7l-6.9 2.5c-1.4.5-2.3 1.8-2.3 3.3v1.9h24.8v-1.9c0-1.5-.9-2.8-2.3-3.3L17 20.9c-.3-.1-.5-.4-.5-.7v-4.1h1.4v3.6l6.4 2.3c1.9.7 3.2 2.5 3.2 4.6v2.6c0 .5-.3.8-.7.8zM13.6 18.1c-4.2 0-7.6-4-7.6-9S9.4 0 13.6 0s7.6 4.1 7.6 9.1-3.5 9-7.6 9zm0-16.7c-3.4 0-6.2 3.4-6.2 7.7s2.8 7.7 6.2 7.7 6.2-3.4 6.2-7.7-2.8-7.7-6.2-7.7zm5 7.8c-1.7 0-3.2-.9-4-2.3-1.4 1.4-3.2 2.1-5.1 2.2-1 0-2.1-.2-3-.7l.6-1.2c.7.4 1.5.6 2.3.6 1.8 0 3.9-1.1 4.6-2.3.1-.4.4-.5.6-.5.3 0 .5.1.6.4 1.2 2.1 2.4 2.7 4.4 2.4.2 0 .3 0 .5-.1h.2l.2 1.3h-.6c-.4.1-.9.2-1.3.2z"
                />
              </svg>
              <span>Just Me</span>
            </div>
          </button>
        )}

        {state.filteredTimeslots ? (
          <div className="filteredState_view">
            <div className="filteredState_viewParent">
              <div className="filteredState_viewButton">
                <Button onClick={() => {}} className="svgIcon_location">
                  <SvgLocations />{" "}
                  {state.locationFilterName !== "Location"
                    ? state.locationFilterName
                    : "Location"}
                </Button>
                {state.locationFilterName !== "Location" ? (
                  <div
                    className="search_loc_selector_reset"
                    data-value="Location"
                  >
                    X
                  </div>
                ) : null}
              </div>

              <div className="filteredState_viewButton">
                <Button
                  onClick={handleClickOpenNurses}
                  className="svgIcon_hospital"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 472 514.3"
                  >
                    <path d="M314.7 243.6V81.2L236 0l-78.7 81.2v54.1H0v379h472V243.6H314.7zM104.9 460.2H52.4V406h52.4v54.2zm0-108.3H52.4v-54.1h52.4v54.1h.1zm0-108.3H52.4v-54.1h52.4v54.1zm157.3 216.6h-52.4V406h52.4v54.2zm0-108.3h-52.4v-54.1h52.4v54.1zm0-108.3h-52.4v-54.1h52.4v54.1zm0-108.3h-52.4V81.2h52.4v54.1zm157.3 324.9h-52.4V406h52.4v54.2zm0-108.3h-52.4v-54.1h52.4v54.1z" />
                  </svg>
                  {state.providerFilterName !== "Nurse/Doctor"
                    ? state.providerFilterName
                    : "Nurse/Doctor"}
                </Button>
                {state.providerFilterName !== "Nurse/Doctor" ? (
                  <div
                    className="search_loc_selector_reset"
                    onClick={handleProviderSelectAll}
                    onKeyDown={handleProviderSelectAll}
                    data-value="Nurse/Doctor"
                    role="presentation"
                  >
                    X
                  </div>
                ) : null}
              </div>

              <div className="filteredState_viewButton">
                <button
                  onClick={() => {}}
                  className={`meAndMyFriend ${
                    state.oneHourAppointments ? "durationToggleOn" : ""
                  }`}
                >
                  <div className="toggleTimeslotDuration_wrapper">
                    {state.toggleTimeslotDuration ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 39 30.5"
                        style={{ width: "28px" }}
                      >
                        <path d="M23.6 30.5H.8c-.4 0-.8-.4-.8-.8v-2.4c0-2 1.2-3.7 3.1-4.4l5.1-2.1v-3h1.6v3.6c0 .3-.2.6-.5.8l-5.6 2.3c-1.2.4-2 1.6-2 2.9V29h21.1v-1.6c0-1.3-.8-2.4-2-2.9l-5.6-2.3c-.3-.1-.5-.4-.5-.8v-3.8h1.6v3.2l5.1 2.1c1.8.7 3 2.4 3 4.4v2.4c0 .5-.4.8-.8.8zM12 19.6c-4 0-7.2-3.8-7.2-8.6S8 2.5 12 2.5s7.2 3.8 7.2 8.6-3.2 8.5-7.2 8.5zm0-15.5c-3.1 0-5.6 3.1-5.6 6.9s2.5 6.9 5.6 6.9 5.6-3.1 5.6-6.9-2.5-6.9-5.6-6.9zm4.7 7.2c-1.5 0-2.9-.8-3.8-2-1.3 1.2-3 1.9-4.8 1.9-1 0-2-.2-2.9-.7L6.1 9c.6.3 1.4.5 2.1.5 1.6 0 3.1-.8 4.1-2.1.1-.3.4-.4.7-.4.3 0 .6.1.7.4 1.1 1.9 2.1 2.4 3.9 2.1h.7l.2 1.6H18c-.5.1-.9.2-1.3.2zm21.5 16.8H23.6v-1.6h13.8v-1.6c0-1.3-.8-2.4-2-2.9l-5.6-2.3c-.3-.1-.5-.4-.5-.8v-3.8h1.6v3.2l5.1 2.1c1.8.7 3 2.4 3 4.4v2.4c0 .5-.4.9-.8.9zm-20.7-5.8l-.9-1.3c.3-.2.7-.4 1.1-.6l5.1-2.1v-3h1.6v3.6c0 .3-.2.6-.5.8L18.3 22c-.3 0-.5.2-.8.3zm9.2-5.2c-4 0-7.2-3.8-7.2-8.6S22.7 0 26.7 0s7.2 3.8 7.2 8.6-3.3 8.5-7.2 8.5zm0-15.5c-3.1 0-5.6 3.1-5.6 6.9s2.5 6.9 5.6 6.9 5.6-3.1 5.6-6.9-2.6-6.9-5.6-6.9zm4.6 7.2c-1.5 0-2.9-.8-3.8-2-1.3 1.2-3 1.9-4.8 1.9-1 0-2-.2-2.9-.7l.8-1.4c.6.3 1.4.5 2.1.5 1.6 0 3.1-.8 4.1-2 .1-.3.4-.4.7-.4.3 0 .6.2.7.4 1.1 1.9 2.1 2.4 3.9 2.1h.7l.2 1.6h-1.7z" />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 27.5 30"
                      >
                        <path
                          className="st0"
                          d="M26.8 30H.7c-.4 0-.7-.3-.7-.7v-2.6c0-2.1 1.3-3.9 3.2-4.6l6.4-2.3v-3.3H11v3.8c0 .3-.2.6-.5.7l-6.9 2.5c-1.4.5-2.3 1.8-2.3 3.3v1.9h24.8v-1.9c0-1.5-.9-2.8-2.3-3.3L17 20.9c-.3-.1-.5-.4-.5-.7v-4.1h1.4v3.6l6.4 2.3c1.9.7 3.2 2.5 3.2 4.6v2.6c0 .5-.3.8-.7.8zM13.6 18.1c-4.2 0-7.6-4-7.6-9S9.4 0 13.6 0s7.6 4.1 7.6 9.1-3.5 9-7.6 9zm0-16.7c-3.4 0-6.2 3.4-6.2 7.7s2.8 7.7 6.2 7.7 6.2-3.4 6.2-7.7-2.8-7.7-6.2-7.7zm5 7.8c-1.7 0-3.2-.9-4-2.3-1.4 1.4-3.2 2.1-5.1 2.2-1 0-2.1-.2-3-.7l.6-1.2c.7.4 1.5.6 2.3.6 1.8 0 3.9-1.1 4.6-2.3.1-.4.4-.5.6-.5.3 0 .5.1.6.4 1.2 2.1 2.4 2.7 4.4 2.4.2 0 .3 0 .5-.1h.2l.2 1.3h-.6c-.4.1-.9.2-1.3.2z"
                        />
                      </svg>
                    )}
                    {state.toggleTimeslotDuration
                      ? "Me + My Friend"
                      : "Just Me"}
                  </div>
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div className="filterNurseDoctor_wrapper _colorMaroon">
              <Button
                onClick={handleCallScheduling}
                className="filterNurseDoctor"
              >
                {state.locationFilterName !== "Location"
                  ? state.locationFilterName
                  : "Schedule a Phone Visit"}
              </Button>
              {state.locationFilterName !== "Location" ? (
                <div
                  className="search_loc_selector_reset"
                  onClick={handleLocationSelectAll}
                  onKeyDown={handleLocationSelectAll}
                  data-value="Location"
                  role="presentation"
                >
                  X
                </div>
              ) : null}
            </div>

            <div className="filterNurseDoctor_wrapper _colorGreen">
              <Button
                onClick={handleClickOpenNurses}
                className="filterNurseDoctor"
              >
                {state.providerFilterName !== "Nurse/Doctor"
                  ? state.providerFilterName
                  : "Nurse/Doctor"}
              </Button>
              {state.providerFilterName !== "Nurse/Doctor" ? (
                <div
                  className="search_loc_selector_reset"
                  onClick={handleProviderSelectAll}
                  onKeyDown={handleProviderSelectAll}
                  data-value="Nurse/Doctor"
                  role="presentation"
                >
                  X
                </div>
              ) : null}
            </div>
          </div>
        )}
      </div> */}

      <Dialog
        className="_FilterDialog"
        open={state.open}
        TransitionComponent={Transition}
        keepMounted
        fullScreen
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="_FilterDialog_wrapper">
          <button
            className={`sandwitch is-active animateSlideDown ${state.modalIsOpen_animate &&
              "o_n"}`}
            onClick={handleClose}
            style={{ margin: "20px 0 0 0" }}
          >
            <span>close</span>
          </button>

          <a href="../" className="modalLogo">
            <div className="logo logoScheduleWhite" />
          </a>

          <div className="_FilterDialog_inner">
            {state.providerCollection && (
              <div
                className={`search_loc_dropdown ${state.modalIsOpen_animate &&
                  "animate"}`}
                style={{ height: state.height }}
              >
                <div className="search_loc_selector_header">
                  <SvgNurse /> Nurse/Doctor
                </div>
                {Object.keys(state.providerCollection).map(key => (
                  <div className="search_loc_selector" key={key}>
                    <div
                      className="search_loc_selector_placeholder"
                      onClick={e => handleProviderSelect(e)}
                      onKeyDown={e => handleProviderSelect(e)}
                      data-value={state.providerCollection[key].value}
                      role="presentation"
                    >
                      <div className="filterPortrait_wrapper">
                        <div
                          className="filterPortrait"
                          style={{
                            backgroundImage: `url(${
                              state.providerCollection[key].portrait
                            })`
                          }}
                        />
                      </div>
                      <span className="sls_label">
                        {state.providerCollection[key].value}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </Dialog>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    DATA_fetch_providers: state.DATA_fetch_providers,
    DATA_fetch_locations: state.DATA_fetch_locations,
    DATA_fetch_soonest: state.DATA_fetch_soonest,
    DATA_fetch_soonest_triggered: state.DATA_fetch_soonest_triggered,
    DATA_fetch_soonest_ADVANCED: state.DATA_fetch_soonest_ADVANCED,
    dataFetchAppointmentTime: state.dataFetchAppointmentTime,
    selectedTimeslotLocation: state.selectedTimeslotLocation,
    selectedFilterLocationName: state.selectedFilterLocationName,
    dataGeoLocations: state.dataGeoLocations,
    selectedHoursValue: state.selectedHoursValue,
    filteredTimeslots: state.filteredTimeslots,
    UserNavigatorInfo: state.UserNavigatorInfo,
    DATA_fetch_filteredProviders: state.DATA_fetch_filteredProviders
  };
}

// for redux dispatch
function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

// for redux
export default connect(mapStateToProps, mapDispatchToProps)(Header);
